import React from "react";
import "./HowItWorks.css";
import step1 from "../../../Assets/newAsset/step1.webp";
import step2 from "../../../Assets/newAsset/step2.webp";
import step3 from "../../../Assets/newAsset/step3.webp";
import step4 from "../../../Assets/newAsset/step4.webp";
import step5 from "../../../Assets/newAsset/step5.webp";

import boxwater from "../../../Assets/newAsset/boxwater.jpg";

import { LazyLoadImage } from 'react-lazy-load-image-component';

const steps = [step1, step2, step3, step4, step5];

function HowItworks() {
  return (
    <>
      <div className="HowItworksParents">
        <div className="howItworksSteps">
          {steps.map((images, index) => (
            <LazyLoadImage src={images} alt={images}  key={index} delayTime='100'/>
          ))}
        </div>
      </div>
       
    </>
  );
}

export default HowItworks;
